module.exports = __webpack_public_path__ + "static/media/shid_emozhl_logo.3f7b48ac.svg";